import { print } from 'graphql'

import { ReadSyncableStateStatisticsDocument } from 'generated/resources/graphql'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useLazyQuery } from 'modules/core/hooks/useQuery'
import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { toSyncParameters } from 'modules/integrations/lib/parameters'

export const useSyncableStateStatistics = ({ skip = false }: { skip?: boolean } = {}) => {
  const {
    syncEnabled,
    marketplaceIntegration,
    configuration,
    getDataCollectionSource,
    companyId,
    contextParameters,
    isBookkeeperView,
  } = usePrivateIntegrationsSyncContext()

  const dataCollectionSource = getDataCollectionSource()
  const mappedVariables = dataCollectionSource?.mappedVariables
  const queryForSync = dataCollectionSource?.document ? print(dataCollectionSource.document) : null

  const [fetchSyncableStateStatistics, { data, loading }] = useLazyQuery(
    ReadSyncableStateStatisticsDocument
  )

  const graphqlVariablesJson = queryForSync
    ? JSON.stringify({ query: queryForSync, variables: { ...mappedVariables } })
    : undefined

  useUnsafeEffect(() => {
    if (skip || !syncEnabled || !marketplaceIntegration || !companyId) return

    fetchSyncableStateStatistics({
      variables: {
        companyId,
        marketplaceIntegrationId: marketplaceIntegration.id,
        origin: configuration.origin,
        parameters: toSyncParameters(contextParameters),
        graphqlVariablesJson,
      },
      context: {
        isBookkeeperView,
      },
    })
  }, [
    skip,
    syncEnabled,
    marketplaceIntegration,
    companyId,
    isBookkeeperView,
    configuration.origin,
    graphqlVariablesJson,
    contextParameters,
    fetchSyncableStateStatistics,
  ])

  const statistics = data?.integrations?.syncableStateStatisticsConnection?.nodes?.[0]

  return { statistics, loading }
}
